var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChristmasIsland(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0021ad",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b8a42",
    d: "M30 24V0H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m6.68 16.4.15.5h.5l-.4.3.15.49-.4-.3-.4.29.15-.47-.4-.3h.5zm-1.3-5.53-.58.53.06-.78-.78-.12.65-.44-.39-.69.75.24.3-.73.28.72.75-.22-.39.68.65.44-.78.12.06.78zM2.3 15.39l-.58.53.06-.78-.78-.12.65-.44-.4-.68.76.23.29-.73.29.73.75-.23-.4.68.66.44-.78.12.06.79zm6.05-.37-.58.53.06-.78-.78-.12.65-.45-.4-.68.76.23.29-.73.29.73.75-.23-.4.68.65.45-.77.12.06.78zM5.33 21.6l-.58.53.06-.79-.78-.11.65-.45-.39-.68.75.23.29-.73.29.73.75-.23-.4.68.66.45-.78.12.06.78z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc639",
    d: "M11.72 12.78a3.03 3.03 0 1 1 6.06-.22 3.03 3.03 0 0 1-6.06.22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b8a42",
    d: "M12.93 11.38s.92.86 1.4.9c.77.06 1.51-.59 1.51-1.06l.73-.31v.95l.7.48-1.3 1.19v1.43l-.79-.2-.05-.99s-.04-.37-.51-.37-.85-.03-.95-.3a8 8 0 0 0-1.29.19l.82-1.14-.27-.29z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc639",
    d: "M24.64 2.01c.2-.16 2.04 1.68 2.27 2.03.21.35.13 1.67.35 2.27s.42.73.64.6c.22-.14.99 0 1.1.28 0 0-.62.38-.66.64 0 0-1.96.68-3.09 1.26-1.12.57-.83.28-1.76.68-1.37.6-2.6.31-3.5.18-.91-.13-.65-.33 0-.24.63.09 2.55-.11 3.06-.29.5-.18 1.5-.97 1.92-1.17s.94-.92.48-1.37c-.46-.44-1.85-1.06-2.4-1.65-.55-.6-.55-.69.3-.55.87.13 1.62.58 2.03 1 .45.44.84-.13.57-.83-.26-.71-.63-.64-.87-1.28-.25-.64-.64-1.4-.44-1.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChristmasIsland);
export default __webpack_public_path__ + "static/media/christmas-island.56f7f41e0bdc9079e4ebfbfb2b9273b0.svg";
export { ForwardRef as ReactComponent };